﻿import {decodeJson} from "@2d-front-monorepo/core";
import {useEffect} from "react";

import {ChangeEvent, ChangeEventType} from "@2d-front-monorepo/permits-business";
import {API_ENDPOINT} from "../api-endpoint";
import getInstallationId from "./getInstallationId";
import {ReloadEntities, reloadPermits} from "./reloadPermits";

export function useHolderNotifications(): void {
	useEffect(() => {
		const installationId = getInstallationId();
		const sse = new EventSource(`${API_ENDPOINT.root}holders/notifications?installation=${installationId}`, {withCredentials: true});
		sse.addEventListener("message", (messageEvent: MessageEvent<string>) => {
			const events = decodeJson<ChangeEvent[]>(messageEvent.data);
			if (events == null || events.length === 0) {
				return;
			}

			let toReload: ReloadEntities = ReloadEntities.None;
			for (const notification of events) {

				if (notification.type === ChangeEventType.Holder || notification.type === ChangeEventType.Driver || notification.type === ChangeEventType.Residency || notification.type === ChangeEventType.Vehicle) {
					toReload |= ReloadEntities.Holder;

				} else if (notification.type === ChangeEventType.Permit) {
					toReload |= ReloadEntities.Permits;

				} else if (notification.type === ChangeEventType.Reservation) {
					toReload |= ReloadEntities.Reservations;
				}
			}

			void reloadPermits(toReload);
		});
		return () => sse.close();
	}, []);
}
